import { type ValidationError } from '@adv-frontend/form-kit';

export const UINT_IS_REQUIRED_CODE = 'UINT_IS_REQUIRED';

export type UintIsRequiredValidationError = ValidationError<typeof UINT_IS_REQUIRED_CODE>;

export const UINT_IS_REQUIRED_MESSAGE = 'Неверный формат, необходимо положительное целое число или ноль';
